// modifer: styles/jss/nextjs-material-kit-pro/pages/profilePageStyle
import { section, container, title } from 'styles/jss/original/base';

const styles = {
  section,
  container,
  title: {
    ...title,
    '@media (max-width: 640px)': {
      marginBottom: '20px'
    }
  }
};

export default styles;
